import { ValueOf } from 'types/types';

const ViewMode = {
  IDLE: 'idle',
  ADMIN: 'admin',
  CAREGIVER: 'caregiver',
} as const;

type ViewMode = ValueOf<typeof ViewMode>;

export { ViewMode };
